import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { OrderWindow } from '../../../models/order-window.model';

@Component({
  selector: 'app-select-order-window',
  templateUrl: './select-order-window.component.html',
  styleUrls: ['./select-order-window.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SelectOrderWindowComponent {
  @Input() mobile = false;

  @Input() orderWindows: OrderWindow[] = [];

  @Input() selectedOrderWindowId: number;

  @Input() hideTitle = false;

  @Output() changedOrderWindow = new EventEmitter<OrderWindow>();

  constructor() {}

  onChangeOrderWindow($event: {} | Event) {
    if ($event instanceof OrderWindow) {
      this.changedOrderWindow.emit($event);
    }
  }

  formattedLabel(item: OrderWindow): string {
    if (!item.id) {
      return '';
    }
    const state = item.active
      ? '<span class="text-green ms-2">Open</span>'
      : '<span class="text-red ms-2">Closed</span>';
    return `<strong>${item.label}</strong>  (${this.formattedDates(item)}) ${state}`;
  }

  formattedDates(item: OrderWindow) {
    if (!item.start_at || !item.end_at) {
      return;
    }
    return `${item.start_at.format('MMM D YYYY')} - ${item.end_at.format('MMM D YYYY')}`;
  }
}
